// CABECERA ORDENABLE DE UNA TABLA (catálogo; operador, 5-oct-2026: «clic en una cabecera ordena»).
//
// Va como `label` de una `ColumnaDeTabla`: un botón dentro del `<th>` con el título y un
// indicador decorativo (▲ ascendente, ▼ descendente, ↕ sin orden), oculto al lector de
// pantalla. El estado lo anuncia el `aria-sort` del `<th>` (WCAG 1.3.1), que la columna declara
// con `ariaSort` y que esta pieza no puede poner porque no es el `<th>`.
//
// No ordena nada: avisa del clic y quien la usa decide el orden siguiente (y, en la Bandeja,
// se lo pide al servidor).
import type { ReactNode } from 'react';

export type SentidoDelOrden = 'ascending' | 'descending' | 'none';

const FLECHA: Record<SentidoDelOrden, string> = { ascending: '▲', descending: '▼', none: '↕' };

export default function CabeceraOrdenable({ children, sentido, onClick, 'data-testid': testid }: {
  children: ReactNode;
  sentido: SentidoDelOrden;
  onClick: () => void;
  'data-testid'?: string;
}) {
  const activa = sentido !== 'none';
  return (
    <button type="button" data-testid={testid} onClick={onClick}
      className={'inline-flex items-center gap-1 rounded-md px-1 -mx-1 py-0.5 font-semibold hover:bg-white hover:text-ink '
        + (activa ? 'text-marca-profundo' : '')}>
      {children}
      <span aria-hidden="true" className={'text-micro ' + (activa ? '' : 'opacity-50')}>{FLECHA[sentido]}</span>
    </button>
  );
}
